/**
 * SFX playback. Files are generated by scripts/generate-audio.mjs (see
 * ASSET.md section 8.2) and loaded by PreloadScene; call `init()` once
 * (done in BootScene) before any of these fire.
 */

import Phaser from 'phaser';
import { SaveData } from './SaveData';

let sound: Phaser.Sound.BaseSoundManager | null = null;
let enabled = SaveData.getSettings().sfxOn;

function play(key: string, config?: Phaser.Types.Sound.SoundConfig): void {
  if (!enabled || !sound) return;
  sound.play(key, config);
}

export const Sfx = {
  init(soundManager: Phaser.Sound.BaseSoundManager): void {
    sound = soundManager;
  },
  isEnabled(): boolean {
    return enabled;
  },
  setEnabled(value: boolean): void {
    enabled = value;
    SaveData.setSfxOn(value);
  },
  catchCorrect(): void {
    play('sfx_catch_correct');
  },
  catchWrong(): void {
    play('sfx_catch_wrong');
  },
  itemMiss(): void {
    play('sfx_item_miss');
  },
  /** `tier` mirrors the old 660Hz-plus-80Hz-per-tier design from the live-synth version, reproduced here via detune. */
  comboUp(tier: number): void {
    const baseFreq = 660;
    const targetFreq = baseFreq + tier * 80;
    const detune = 1200 * Math.log2(targetFreq / baseFreq);
    play('sfx_combo_up', { detune });
  },
  levelComplete(): void {
    play('sfx_level_complete');
  },
  levelFail(): void {
    play('sfx_level_fail');
  },
  buttonTap(): void {
    play('sfx_button_tap');
  },
  starAward(): void {
    play('sfx_star_award');
  }
};
